<script setup>
import { trans, transchoice } from '@tools/translation';
import { currencyNoDecimal } from '@tools/number-formatter';

defineProps({
  totalPrice: {
    type: Number,
    required: true,
  },
  teamSize: {
    type: Number,
    required: true,
  },
  totalOffersCount: {
    type: Number,
    required: true,
  },
});
</script>

<template>
  <div class="office-chooser__total">
    <p class="office-chooser__total__title">
      {{ trans('multioffice.total') }}
    </p>

    <div>
      <div class="office-chooser__total__price-container">
        <span class="office-chooser__total__price">
          {{ currencyNoDecimal(totalPrice) }}
        </span>

        <span>
          {{ trans('global.price_tax') }}
          {{ trans('offer.price_per_month_short') }}
        </span>
      </div>

      <span class="office-chooser__total__specs">
        {{ transchoice('multioffice.total.offers_count', { count: totalOffersCount }) }}
        •
        {{ teamSize }} {{ transchoice('multioffice.capacity', { count: teamSize }) }}
      </span>
    </div>
  </div>
</template>
